import { GroupTitle } from "./StyledComponents"
import LocalizedStrings from 'react-localization';

import { ClientLanguage, getClientLanguageAsString } from "../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        messageEmptyJobList:"Zur Zeit sind keine Stellenanzeigen ausgeschrieben.",
    },
    en: 
    {
        messageEmptyJobList:"There are currently no job postings.",
    }
});

interface EmptyJobListViewProps{
    clientLanguage?: ClientLanguage
}

export const EmptyJobListView = (props: EmptyJobListViewProps) => {

    setLanguage();

    function setLanguage(): void {
        switch(props.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    return (
        <GroupTitle style={{marginTop: "30px"}}>{locStrings.messageEmptyJobList}</GroupTitle>
    )
}